export function Card({ className = "", children, ...props }) {
    const classes = ["aurora-surface", className].filter(Boolean).join(" ")
    return (
        <div className={classes} {...props}>
            {children}
        </div>
    )
}

export function CardHeader({ className = "", children, ...props }) {
    const classes = ["aurora-surface__header", className].filter(Boolean).join(" ")
    return (
        <header className={classes} {...props}>
            {children}
        </header>
    )
}

export function CardContent({ className = "", children, ...props }) {
    const classes = ["aurora-surface__content", className].filter(Boolean).join(" ")
    return (
        <div className={classes} {...props}>
            {children}
        </div>
    )
}

export function CardFooter({ className = "", children, ...props }) {
    const classes = ["aurora-surface__footer", className].filter(Boolean).join(" ")
    return (
        <footer className={classes} {...props}>
            {children}
        </footer>
    )
}

export function CardTitle({ className = "", children, as = "h3", ...props }) {
    const Component = as
    const classes = ["text-lg font-semibold tracking-tight", className].filter(Boolean).join(" ")
    return (
        <Component className={classes} {...props}>
            {children}
        </Component>
    )
}

export function CardDescription({ className = "", children, ...props }) {
    const classes = ["text-sm text-muted-foreground leading-relaxed", className].filter(Boolean).join(" ")
    return (
        <p className={classes} {...props}>
            {children}
        </p>
    )
}

export default Card




